import selectTree from './src/';

export default selectTree;


// WEBPACK FOOTER //
// ./src/components/select-tree/index.js